

























import { Component, Prop, Vue } from "vue-property-decorator";
import { ICategoryTopArticles } from "@/store/interfaces/article";
import ArticleCard from "@/components/articles/ArticleCard.vue";
import SubscriptionForm from "@/components/common/subscription/SubscriptionForm.vue";

@Component({
  name: "MainPageCategory",
  components: {
    ArticleCard,
    SubscriptionForm
  }
})
export default class MerchantCard extends Vue {
  @Prop({ default: null })
  category: ICategoryTopArticles;

  @Prop({ default: false })
  position: number;

  mounted() {
    // Remove last article for third category
    if (this.position === 2 && this.category.articles.length === 3) {
      this.category.articles.splice(2, 1);
    }
  }
}
